import { RootAction, RootState } from '@src/app/_redux';
import {
  ActionsObservable,
  StateObservable,
  ofType,
  combineEpics,
} from 'redux-observable';
import { INITIATE_OMS_LOOKUP } from '@src/app/login/oms/actions';
import {
  UNAUTH_GET_IAM_KEYS,
  AUTH_IAM_KEYS_SUCCESS,
} from '@src/app/login/weak/actions';
import { removeAll } from 'react-notification-system-redux';
import { COGNITO_SUCCESS } from '@src/app/login/cognito/actions';

import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

const removeAllNotificationsEpic = (action$: ActionsObservable<RootAction>) =>
  action$.pipe(
    ofType(
      UNAUTH_GET_IAM_KEYS,
      INITIATE_OMS_LOOKUP,
      AUTH_IAM_KEYS_SUCCESS,
      COGNITO_SUCCESS,
    ),

    mergeMap((action, payload) => {
      return of(removeAll());
    }),
  );

export const epics = combineEpics(removeAllNotificationsEpic);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/notifications/epics.ts